<script lang="ts">
    import SearchBar from '$saga/views/Search/SearchBar.svelte';
</script>

<SearchBar />
